<template>
    <div class="uk-grid-medium" uk-grid>

        <!-- Filters -->


                        <filters v-if="ShopFilterProperties.length !==0" @filter-changed="filterChanged"
                                 :filter-properties="page.ShopFilterProperties"
                                 :filter-property-values="page.ShopFilterPropertyValues"
                                 :selected-property-values="page.selectedPropertyValues"></filters>



        <!-- Tags & Items -->
        <div class="uk-width-1-1 uk-width-expand@m">

            <div class="uk-grid-medium uk-child-width-1-1" uk-grid>

                <!-- Tags -->
                <div v-if="ShopGroup">
                    <div class="uk-grid-small tm-all-tags" uk-grid>
                        <shop-tag  v-for="ShopTag in ShopTags"
                                   :shop-tag="ShopTag"
                                   :shop-items="page.ShopItems.items"
                                   :shop-item-tags="page.ShopItemTags"
                                   :key="ShopTag.id">
                        </shop-tag>
                    </div>
                </div>

                <!-- Pagination -->
                <shop-items-pagination
                        @load-page="loadPage"
                        :total-pages="page.ShopItems.total_pages"
                        :last-page="page.ShopItems.last"
                        :current-page="page.ShopItems.current"
                        :next-page="page.ShopItems.next"
                        :previous-page="page.ShopItems.before"
                        v-on="$listeners"
                ></shop-items-pagination>


                <!-- Items -->
                <div>
                    <div v-bind:class="[page.ShopFilterProperties.length !== 0 ? 'uk-child-width-1-3@l' : 'uk-child-width-1-4@l']"
                         class="uk-grid-medium uk-child-width-1-1 uk-child-width-1-2@s js-list-item-cards"
                         uk-grid>
                        <div v-for="Product in page.ShopItems.items">
                        <shop-item-block
                                         :shop-item="Product.ShopItem"
                                         :shop-item-prices="page.ShopItemPrices[Product.ShopItem.id]"
                                         :key="Product.ShopItem.id"
                                         :shop-item-properties="page.ShopItemProperties[Product.ShopItem.id]"
                                         :shop-item-warehouses="page.ShopItemWarehouses[Product.ShopItem.id]"
                                         :shop-item-tags="page.ShopItemTags[Product.ShopItem.id]"
                                         :shop-order-item="page.ShopOrderItems[Product.ShopItem.id]"
                                         @buy-shop-item="buy">
                        </shop-item-block>
                        </div>
                    </div>
                </div>

                <!-- Pagination -->
                <shop-items-pagination
                        @load-page="loadPage"
                        :total-pages="page.ShopItems.total_pages"
                        :last-page="page.ShopItems.last"
                        :current-page="page.ShopItems.current"
                        :next-page="page.ShopItems.next"
                        :previous-page="page.ShopItems.before"
                        v-on="$listeners"
                ></shop-items-pagination>

            </div>

            <a class="uk-button uk-button-primary" id="js-scroll" style="display: none; margin-left: 20px;"></a>

        </div>

        <loading
                :show="loading"
                label="">
            <template slot="loading-spinner">
                <div uk-spinner="ratio: 2"></div>
            </template>
        </loading>
    </div>
</template>

<script>
    import ShopProductsMixin from './../ShopProductsMixin';
    import ShopItemBlock from "./ShopItemBlock";
    import ShopTag from "./ShopTag";
    import Filters from "./Filters";
    import loading from 'vue-full-loading';
    import ShopItemsPagination from "./../ShopItemsPagination";

    export default {
        components: {ShopItemsPagination, Filters, ShopItemBlock, ShopTag, loading},
        mixins: [ShopProductsMixin],
        props: {
            ShopGroup: {
                type: Object,
                required: true
            },
            ShopTags: {
                type: Array,
            },
            ShopFilterProperties: {
                type: Array,
                default() {
                    return []
                }
            },
            ShopFilterPropertyValues: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            selectedPropertyValues: {
                type: [Array, Object],
                default() {
                    return null
                }
            }
        },
        created() {
            this.bindHistoryManipulation(location.href, this.params)
        },
        data() {
            return {
                page: {
                    ShopItems: this.ShopItems,
                    ShopGroup: this.ShopGroup,
                    ShopItemPrices: this.ShopItemPrices,
                    ShopItemsRelated: this.ShopItemsRelated,
                    ShopItemProperties: this.ShopItemProperties,
                    ShopFilterProperties: this.ShopFilterProperties,
                    ShopFilterPropertyValues: this.ShopFilterPropertyValues,
                    selectedPropertyValues: this.selectedPropertyValues,
                    ShopItemWarehouses: this.ShopItemWarehouses,
                    ShopItemTags: this.ShopItemTags,
                    ShopOrderItems: this.ShopOrderItems
                },
                params: {
                    propertyValues: this.selectedPropertyValues,
                    page: 1
                },
            }
        },
        methods: {
            filterChanged(propertyId, propertyValues) {
                this.params.propertyValues = {...this.params.propertyValues, ...{[propertyId]: propertyValues}};
                this.params.page = 1;
                this.fetchShopItems(this.page.ShopGroup.href, this.params, true, false);
            },
            loadPage(page) {
                if(page == 'prev'){
                    this.params.page = this.params.page - 1;
                }else if(page == 'next'){
                    this.params.page = this.params.page + 1;
                }else{
                    this.params.page = page;
                }
                this.fetchShopItems(this.page.ShopGroup.href, this.params);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ShopItemsList.vue?10a6ec70